import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import Button from '../Button';
import Image from '../Image';
import Header from '../Header';
import './styles.css';

const SubscriptionModuleComponent = ({
  category,
  color,
  title,
  description,
  buttonLabel,
  image,
  link,
}) => (
  <div data-cy="homepage-subscription-tabs" styleName={`subscription-module ${color}`}>
    <div styleName="module-category">{category}</div>
    <div styleName="module-image">
      <Image src={image} aria-hidden="true" alt="" />
    </div>
    <div styleName="module-content">
      <Header as="h2" size="large" data-cy={`homepage-subscription-title-${kebabCase(buttonLabel)}`}>{title}</Header>
      <div data-cy={`homepage-subscription-description-${kebabCase(buttonLabel)}`} styleName="module-description">{description}</div>
      <div>
        <Button
          data-cy={`homepage-subscription-btn-${kebabCase(buttonLabel)}`}
          as={Link}
          to={link}
          styleName="module-button"
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  </div>
);

SubscriptionModuleComponent.propTypes = {
  category: PropTypes.node,
  color: PropTypes.oneOf(['blue', 'darkcyan', 'grey']).isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  buttonLabel: PropTypes.node.isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default SubscriptionModuleComponent;
